import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { PrimaryButton } from "./PrimaryButton";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { FlatButton } from "./FlatButton";
import { SizedBox } from "./SizedBox";
import { Web3Context } from "../contexts/Web3Context";
import { useLocation, useNavigate } from "react-router-dom";
import IconButton from "./IconButton";
import { IoSunnySharp } from "react-icons/io5";
import { BsFillMoonFill } from "react-icons/bs";
import { MdOutlineInsertLink } from "react-icons/md";
import { useAppColors } from "../utils/useAppColors";
import OptionsBottomSheet from "./OptionsBottomSheet";
import ChainSelectModal from "./ChainSelectModal";
import { FaUser } from "react-icons/fa";
import Logo from "../schedulebondlogo.png";

const ScheduleBannerImg = styled.img`
  width: 145px;
  height: auto;
`;

const dappUrl = "schedule.bond";

const ScheduleNavWrapper = styled.nav`
  width: 100%;
  background-color: ${(props) => props.backgroundColor};
  border: none;
  color: #130d0d;
  font-size: 20px;
  padding: 20px 40px 20px 40px;
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.12);
  -o-box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.12);
`;

const ScheduleNavWrapperMobile = styled.nav`
  width: 100%;
  background-color: ${(props) => props.backgroundColor};
  border: none;
  color: #130d0d;
  font-size: 20px;
  padding: 10px 0 10px 0;
`;
const ScheduleNavInnerWrapper = styled.nav`
  width: 80%;
`;

const ScheduleNavInnerWrapperMobile = styled.nav`
  width: 90%;
`;

const ScheduleWord = styled.div`
  font-size: ${(props) => (props.fontSize ? props.fontSize : "32px")};
  color: ${(props) => props.color} !important;
  font-weight: bold;
`;
const ScheduleBond = styled.div`
  font-size: ${(props) => (props.fontSize ? props.fontSize : "32px")};
  color: ${(props) => props.color};
  font-weight: bold;
`;

const ScheduleTitleWrapper = styled.a`
  cursor: pointer;
  text-decoration: none;
`;

const LogoImage = styled.img`
  height: 48px;
  width: 48px;
`;

const LogoImageMobile = styled.img`
  height: 28px;
  width: 28px;
`;

export const ScheduleNav = ({ name, placeholder, isLoggingIn }) => {
  const location = useLocation();

  const navigate = useNavigate();
  const { theme, setTheme } = useContext(Web3Context);
  const { user, account, logout, login } = useContext(Web3Context);
  const colors = useAppColors();
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [chainModalOpen, setChainModalOpen] = useState(false);
  const [deepLink, setDeepLink] = useState(
    "https://metamask.app.link/dapp/" +
      dappUrl +
      location.pathname +
      location.search
  );

  useEffect(() => {
    setDeepLink(
      "https://metamask.app.link/dapp/" +
        dappUrl +
        location.pathname +
        location.search
    );
  }, [location]);

  useEffect(() => {}, [account]);

  // Prefer the account's name in the nav; fall back to a short address.
  const shortAddress =
    typeof account === "string" && account.length > 8
      ? account.slice(0, 5) + "..." + account.slice(-4)
      : account;
  const accountLabel = user
    ? user.username || user.displayName || shortAddress || "Account"
    : "";

  return (
    <div>
      <BrowserView>
        <ScheduleNavWrapper
          backgroundColor={colors.navColor}
          className="d-flex justify-content-center"
        >
          <ScheduleNavInnerWrapper className="d-flex justify-content-between">
            <ScheduleTitleWrapper
              className="d-flex"
              href="https://schedule.bond/"
            >
              <LogoImage src={Logo} />
              {/* <ScheduleWord>🔗</ScheduleWord> */}
              <SizedBox width={8} />
              <ScheduleWord
                color={theme === "light" ? "black" : "white"}
                className="scheduleNavTitle"
              >
                Schedule
              </ScheduleWord>
              <ScheduleBond
                color={colors.primaryColor}
                className="scheduleNavTitle"
              >
                .bond
              </ScheduleBond>
            </ScheduleTitleWrapper>

            <div className="d-flex align-items-center">
              {/* <IconButton
                Icon={theme === "light" ? BsFillMoonFill : IoSunnySharp}
                onClick={() => {
                  setTheme(theme === "light" ? "dark" : "light");
                }}
              /> */}
              {user && account && (
                <IconButton
                  Icon={FaUser}
                  onClick={() => {
                    setOptionsOpen(true);
                  }}
                />
              )}
              <SizedBox width={32} />
              <PrimaryButton
                isLoading={isLoggingIn}
                onClick={
                  user && account
                    ? () => {
                        setOptionsOpen(true);
                      }
                    : () => setChainModalOpen(true)
                }
                text={
                  user && account && typeof account === "string"
                    ? accountLabel
                    : "Connect Wallet"
                }
                padding={"10px 20px 10px 20px"}
                borderRadius={"18px"}
              />
            </div>
          </ScheduleNavInnerWrapper>
        </ScheduleNavWrapper>
      </BrowserView>
      <MobileView>
        <ScheduleNavWrapperMobile
          backgroundColor={colors.navColor}
          className="d-flex justify-content-center"
        >
          <ScheduleNavInnerWrapperMobile className="d-flex justify-content-between align-items-center">
            <ScheduleTitleWrapper
              className="d-flex"
              href="https://schedule.bond/"
            >
              <LogoImageMobile src={Logo} />
              {/* <ScheduleWord fontSize="20px">🔗</ScheduleWord> */}
              <SizedBox width={8} />
              <ScheduleWord
                fontSize="20px"
                color={theme === "light" ? "black" : "white"}
                className="scheduleNavTitle"
              >
                Schedule
              </ScheduleWord>
              <ScheduleBond
                fontSize="20px"
                color={colors.primaryColor}
                className="scheduleNavTitle"
              >
                .bond
              </ScheduleBond>
            </ScheduleTitleWrapper>
            {isMobile && !window.ethereum ? (
              <a href={deepLink}>
                <PrimaryButton
                  // onClick={user ? logout : login}
                  isLoading={isLoggingIn}
                  text={
                    user && typeof account === "string"
                      ? accountLabel
                      : "Connect"
                  }
                />
              </a>
            ) : (
              <>
                {user && account ? (
                  <div className="d-flex align-items-center">
                    <IconButton
                      Icon={FaUser}
                      onClick={() => {
                        setOptionsOpen(true);
                      }}
                    />
                    <SizedBox width={12} />
                    <IconButton
                      Icon={MdOutlineInsertLink}
                      onClick={() => setOptionsOpen(true)}
                      color={"white"}
                      backgroundColor={colors.primaryColor}
                    />
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    {user && account && (
                      <IconButton
                        Icon={FaUser}
                        onClick={() => {
                          setOptionsOpen(true);
                        }}
                      />
                    )}
                    <PrimaryButton
                      onClick={
                        user ? logout : () => setChainModalOpen(true)
                      }
                      isLoading={isLoggingIn}
                      text={
                        user && typeof account === "string"
                          ? accountLabel
                          : "Connect Wallet"
                      }
                    />
                  </div>
                )}
              </>
            )}
          </ScheduleNavInnerWrapperMobile>
        </ScheduleNavWrapperMobile>
      </MobileView>
      <OptionsBottomSheet open={optionsOpen} setOpen={setOptionsOpen} />
      <ChainSelectModal open={chainModalOpen} setOpen={setChainModalOpen} />
    </div>
  );
};
